<h1 mat-dialog-title>Mobile Upload Required</h1>
<div mat-dialog-content *ngIf="idType === 'license'">
    <p>
        For security reasons, driver's licenses can only be uploaded from a mobile device. Click the secure link on your phone to take a picture of the license.
    </p>
</div>
<div mat-dialog-content *ngIf="idType === 'extendedId'">
    <p>
        For security reasons, identification documents can only be uploaded from a mobile device. Click the secure link on your phone to take a picture of the
        ID.
    </p>
</div>
<div class="ok-wrap">
    <button mat-button class="primary" (click)="ok()" type="submit">Ok</button>
</div>
